import styled from 'styled-components';

export const DifferenceBanner =styled.section``;

export const DonationDifferenceTitle =styled.h2`
    color: #333333;
    font-family: "Jost", sans-serif;
    font-size: 30px;
    font-weight: 600;
    line-height: 40px;
    margin-bottom: 30px;

    @media screen and (max-width: 991px){
        font-size: 28px;
        line-height: 40px;
    }

    @media screen and (max-width: 767px){
        font-size: 26px;
        line-height: 38px;
    }

    @media screen and (max-width: 575px){
        font-size: 24px;
        line-height: 36px;
    }
`;

export const MakeDifference =styled.div`
    display:flex;
    gap:24px;

    @media screen and (max-width: 767px){
        gap:15px;
    }
    @media screen and (max-width: 575px){
        display: flex;
        justify-content: flex-start;
        align-items: flex-start;
        flex-direction: column;
    }
`;

export const DonationMake =styled.div`
    background: #D4ECEE 0% 0% no-repeat padding-box;
    border-radius: 20px;
    padding:30px;
    text-align: center;
    width: calc(33.33% - 10px);
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    gap: 30px;

    @media screen and (max-width: 991px){
        padding:20px;
        border-radius: 15px;
    }
    @media screen and (max-width: 767px){
        padding:15px;
        gap: 15px;
    }
    @media screen and (max-width: 575px){
        width: 100%;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        text-align: center;
    }
`;

export const DonationImage =styled.div`
    max-height: 190px;
    max-width: 190px;
    display: flex;

    @media screen and (max-width: 991px){
        max-height: 150px;
        max-width: 150px;
    }

    @media screen and (max-width: 575px){
        max-width: 130px;
    }

    img{
        width: 100%;
        display: block;
        object-fit: contain;
    }
`;

export const DonationTitle =styled.h3`
    width:100%;
    color: #333333;
    font-family: "Jost", sans-serif;
    margin-bottom: 0px;

    &.dollar-dollar-title{
        font-size:40px;
        font-weight: 700;
        line-height:58px;

        @media screen and (max-width: 991px){
            font-size:36px;
            line-height:54px;
        }

        @media screen and (max-width: 767px){
            font-size:26px;
            line-height:44px;
        }
    }
    
    &.donation-text-title{
        font-size: 24px;
        font-weight: 500;
        line-height: 34px;
        display: none;
    }
`;

export const DonationText =styled.p`
    color: #333333;
    font-family: "Jost", sans-serif;
    font-size:18px;
    font-weight: 400;
    line-height:27px;
    margin-bottom: 0px;

    @media screen and (max-width: 767px){
        font-size: 16px;
        line-height: 22px;
    }

`;
export const DonationTextCol =styled.div`
    display: flex;
    flex-wrap: wrap;
    gap: 20px;

    @media screen and (max-width: 767px){
        gap: 15px;
    }
    @media screen and (max-width: 767px){
        gap: 10px;
        text-align: center;
        justify-content: center;
    }
`;
